module.exports = __webpack_public_path__ + "static/event-6-259f0b6559fe643076d539428ab221ab.mp4";